import {useEventBus} from "../../../assets-dev/ts/modules/use-event-bus";

export class ChangeLanguage {
    private el: HTMLElement;


    private selectedFlagHolderEl: HTMLElement | null;
    private englishFlagEl: HTMLElement | null;
    private tooltipEl: HTMLElement | null;
    private selectedLanguageEl: HTMLElement | null;

    private selectedFlagHolderFn;

    private isOpenTooltip = false;
    private waitForLanguageTimeout;
    private retries = 0;
    private maxRetries = 50;
    private availableLanguages: string[] = [];
    private currentLanguage: string = '';

    constructor(el: HTMLElement) {
        this.el = el;
        this.selectedFlagHolderEl = el.querySelector('.hd-change-language__selected-flag-holder');
        this.selectedLanguageEl = el.querySelector('.goog-te-menu-value > span');

        this.englishFlagEl = el.querySelector('a[title="English"]');
        this.tooltipEl = el.querySelector('.hd-change-language__tooltip-content');
        if (this.tooltipEl) {
            this.availableLanguages = Array.from(this.tooltipEl.querySelectorAll('#flags a'))
                .map(e => (<HTMLElement>e).dataset.lang || '')
                .filter(e => e !== '');
        }
    }


    public onInit() {
        if (this.selectedFlagHolderEl) {
            this.selectedFlagHolderFn = this.onSelectedFlagClick.bind(this);
            this.selectedFlagHolderEl.addEventListener('click', this.selectedFlagHolderFn)
        }

        this.waitForLanguage();
    }

    public onDestroy() {
        if (this.selectedFlagHolderEl && this.selectedFlagHolderFn) {
            this.selectedFlagHolderEl.removeEventListener('click', this.selectedFlagHolderFn);
        }
    }

    private waitForLanguage() {
        if (this.retries >= this.maxRetries) {
            return;
        }
        this.retries++;
        clearTimeout(this.waitForLanguageTimeout);
        const timeoutTime = Math.min(1000, this.retries * 50);
        this.waitForLanguageTimeout = setTimeout(() => {
            this.selectedLanguageEl = this.el.querySelector('.goog-te-menu-value > span');
            if (!this.selectedLanguageEl) {
                this.waitForLanguage();
            } else {
                this.wow();
            }
        }, timeoutTime);
    }

    private wow() {
        this.el.classList.add('visible');
        if (!this.selectedLanguageEl) {
            return;
        }
        const fn = this.onObserve.bind(this);
        var observer = new MutationObserver(fn);
        observer.observe(this.selectedLanguageEl, {
            childList: true
        });
        setTimeout(() => {
            this.onObserve();
        }, 1000);
    }

    private onObserve() {
        if (!this.selectedLanguageEl) {
            return;
        }
        const msg = this.selectedLanguageEl.innerText || this.selectedLanguageEl.innerHTML;
        if (this.availableLanguages.includes(msg)) {
            this.setActiveFlag(msg);
        } else {
            if (msg === 'Haitian Creole') {
                this.setActiveFlag('Haitian');
            } else {
                this.setActiveFlag('English');
            }
        }
    }

    private setActiveFlag(lang) {
        if (this.currentLanguage === lang) {
            return;
        }
        this.currentLanguage = lang;
        if (!this.selectedFlagHolderEl) {
            return;
        }
        const additionalClassesEl = this.tooltipEl ? this.tooltipEl.querySelector(`a[title="${lang}"]`) : null;
        const additionalClasses = additionalClassesEl && additionalClassesEl.classList.toString() || 'notranslate nturl';
        this.selectedFlagHolderEl.innerHTML = `<a title="${lang}" class="${additionalClasses}"></a>`;
    }

    private onSelectedFlagClick() {
        this.isOpenTooltip = !this.isOpenTooltip;
        if (!this.tooltipEl) {
            return;
        }
        if (this.isOpenTooltip) {
            this.tooltipEl.classList.add('open');
        } else {
            this.tooltipEl.classList.remove('open');
        }
    }

}

export function useChangeLanguage() {
    useEventBus('hd-change-language', ChangeLanguage);
}